export { default as default } from './CodiEspectador';
